import { Outlet } from 'react-router';

import { useBrand } from '../../shared/branding/brand-provider';
import Tutorial from '../tutorial/Tutorial';
import Welcome from '../tutorial/Welcome';
import { AuthGate } from './AuthGate';

export const PrivateRoute = () => {
  const isWhitelabel = useBrand().clientName !== 'default';

  return (
    <AuthGate>
      {!isWhitelabel && <Welcome />}
      <Tutorial />
      <Outlet />
    </AuthGate>
  );
};
